import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import {
  HSAmendmentRequestData,
  IContractHealthSystem,
  THSAmendmentFile,
  TGetHealthSystemsRequest
} from 'features/ContractDetails/Facilities/types'
import Fetcher from 'services/Fetcher'
import { ResponseWithPagination } from '../../../constants'

const fetcher = new Fetcher({})

export const getContractHealthSystems: TGetHealthSystemsRequest = async (
  id,
  data
) =>
  fetcher.request<unknown, ResponseWithPagination<IContractHealthSystem>>({
    url: `${API_DICTIONARY.CONTRACTS}${id}/${API_DICTIONARY.FACILITIES}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const uploadHSAmendmentDocumentRequestAsync = async (data: FormData) =>
  fetcher.request<FormData, THSAmendmentFile>({
    url: `${API_DICTIONARY.FILES}${API_DICTIONARY.CONTRACT_AMENDMENT_DOCUMENTS}`,
    method: HTTP_METHODS.POST,
    data
  })

export const addHSAmendmentRequestAsync = async (
  id: string,
  hsId: string,
  data: HSAmendmentRequestData,
  editMode: boolean
) =>
  fetcher.request<HSAmendmentRequestData, unknown>({
    url: `${API_DICTIONARY.CONTRACTS}${id}/${API_DICTIONARY.FACILITIES}${API_DICTIONARY.HEALTH_SYSTEMS}${hsId}/`,
    method: editMode ? HTTP_METHODS.PUT : HTTP_METHODS.POST,
    data
  })

export const addHSAmendmentToHospitalRequestAsync = async (
  id: string,
  hospitalId: string,
  data: HSAmendmentRequestData,
  editMode: boolean
) =>
  fetcher.request<HSAmendmentRequestData, unknown>({
    url: `${API_DICTIONARY.CONTRACTS}${id}/${API_DICTIONARY.FACILITIES}${API_DICTIONARY.HOSPITALS}${hospitalId}/`,
    method: editMode ? HTTP_METHODS.PUT : HTTP_METHODS.POST,
    data
  })
